import { BillingMode, InvoiceStatus, InvoiceType } from '../../../../../../services/exports/Constants';

export default {
  title: 'Laskut',
  form: {
    title: 'Pyydä uusi maksu',
    company: {
      label: 'Ravintola',
    },
    billing_mode: {
      label: 'Laskutuslähde',
    },
    billing_anchor: {
      label: 'Laskutus alkaa',
    },
    items: {
      label: 'Kohteet',
    },
    name: {
      label: 'Nimi',
      placeholder: '1000x esite',
    },
    net_amount: {
      label: 'Summa (NETTO)',
      tax_breakdown: '+{{tax}} ALV = {{total}}',
    },
  },
  fields: {
    id: 'ID',
    company: 'Ravintola',
    name: 'Nimi/Numero',
    billing_mode: 'Laskutuslähde',
    type: 'Tyyppi',
    status: 'Tila',
    amount: 'Summa (Brutto)',
    created_at: 'Luotu',
    billing_anchor: 'Laskutus alkaen',
    invoice: 'Lasku',
  },
  billing_modes: {
    [BillingMode.Stripe]: 'Maksutapa',
    [BillingMode.InternalInvoicing]: 'Myynti',
  },
  types: {
    [InvoiceType.Manual]: 'Manuaalinen',
    [InvoiceType.SetupFee]: 'Käyttöönottomaksu',
    [InvoiceType.Subscription]: 'Tilaus',
  },
  statuses: {
    [InvoiceStatus.Pending]: 'Odottaa',
    [InvoiceStatus.Processing]: 'Käsitellään',
    [InvoiceStatus.Paid]: 'Maksettu',
    [InvoiceStatus.PartiallyRefunded]: 'Osittain hyvitetty',
    [InvoiceStatus.Refunded]: 'Hyvitetty',
    [InvoiceStatus.Failed]: 'Epäonnistui',
  },
  modals: {
    invoice_creation_confirmation: {
      title:
        'Haluatko varmasti luoda laskun summalle {{amount}} NETTO yritykselle {{company}} lähteestä {{billingMode}}?',
    },
    invoice_recharge_confirmation: {
      title: 'Oletko varma?',
      description:
        'Yritykseltä <strong>{{company}}</strong> veloitetaan uudelleen <strong>{{amount}} brutto + mahdollinen maksuvirheen sakko</strong> ensisijaisesta maksutavasta laskulle {{details}}',
      recharge_failed: {
        title: 'Stripe hylkäsi maksun',
        convert_hint:
          'Voit kerätä tämän laskun ravintolan myynnistä sen sijaan. Stripe-lasku mitätöidään ja jäljellä oleva summa vähennetään tulevista tilityksistä.',
      },
    },
  },
  buttons: {
    show_transfers: 'Näytä siirrot',
    hide_transfers: 'Piilota siirrot',
    create: 'Luo',
    download_pdf: 'Lataa PDF',
    open_payment_page: 'Avaa maksusivu',
    open_invoice_page: 'Avaa laskun tiedot',
    add_item: 'Lisää kohde',
    convert_to_internal_billing: 'Kerää myynnistä sen sijaan',
    recharge_invoice: 'Veloita lasku uudelleen',
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataus epäonnistui',
    failed_to_create_invoice: 'Laskun luonti epäonnistui!',
    invoice_got_created: 'Lasku luotiin!',
    invoice_got_recharged: 'Lasku veloitettiin uudelleen. Uutta maksua käsitellään!',
    failed_to_recharge_invoice: 'Laskun uudelleenveloitus epäonnistui!',
    invoice_got_converted_to_internal_billing:
      'Lasku muunnettu myyntilaskutukseksi. Jäljellä oleva summa vähennetään tulevista tilityksistä.',
    failed_to_convert_invoice_to_internal_billing: 'Laskun muuntaminen myyntilaskutukseksi epäonnistui!',
  },
};
